
export default {
  props: {
    blurClasses: {
      type: String,
      default: '',
    },
  },
}
